<template>
    <b-modal
        id="portfolio-edit-deadline-modal"
        v-model="modal"
        :title="$t('portfolio.assignment_deadline')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        size="md"
        :ok-disabled="disabled"
        @ok="storeDeadline">
        <div class="portfolio">
            <div class="deadline-toggle">
                <b-form-checkbox
                    class="apprentice-switch"
                    v-model="enabled"
                    :name="$t('portfolio.set_deadline')"
                    switch>
                    {{ $t('portfolio.set_deadline') }}
                </b-form-checkbox>
            </div>

            <div class="deadline">
                <div class="date">
                    <b-form-group
                        label="Datum"
                        label-for="deadline-datepicker-input">
                        <b-form-datepicker
                            class="apprentice-date-picker btn-date-group"
                            id="deadline-datepicker-input"
                            v-model.lazy="date"
                            :config="dateConfig"
                            start-weekday="1"
                            now-button
                            reset-button
                            right
                            today-variant="primary"
                            nav-button-variant="primary"
                            locale="nl"
                            :aria-controls="$t('portfolio.choose_date')"
                            label-reset-button="reset"
                            :label-no-date-selected="$t('portfolio.no_date_selected')"
                            menu-class="datedropdown"
                            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                            :disabled="!enabled">
                        </b-form-datepicker>
                    </b-form-group>
                </div>

                <div class="time">
                    <b-form-group
                        :label="$t('portfolio.time')"
                        label-for="deadline-timepicker-input">
                        <design-2021-apprentice-timepicker-component
                            v-model.lazy="time"
                            :disabled="!enabled">
                        </design-2021-apprentice-timepicker-component>
                    </b-form-group>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-edit-deadline-modal-component',
    props: {
        groupIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            assignment: {},
            enabled: false,
            time: '12:00',
            date: null,
            dateConfig: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
            },
            timeConfig: {
                format: 'H:mm',
                useCurrent: false,
                labelCloseButton: this.$t('common.close'),
                noCloseButton: true,
                icons: {
                    close: 'fa fa-times-circle',
                },
            },
            modal: false,
        };
    },

    computed: {
        disabled() {
            if (!this.enabled) {
                return false;
            }
            return !this.time || !this.date;
        },
    },

    methods: {
        show(assignment) {
            this.assignment = assignment;
            this.enabled = !!assignment.deadlines.length;
            this.time = !!assignment.deadlines.length ? assignment.deadlines[0].agenda_item.time : '12:00';
            this.date = !!assignment.deadlines.length ? assignment.deadlines[0].agenda_item.date : null;
            this.modal = true;
        },

        storeDeadline() {
            this.alert.saving();

            const data = {
                id: !!this.assignment.deadlines.length ? this.assignment.deadlines[0].id : null,
                date: this.date,
                time: this.time,
                group_id: this.groupIn.id,
                assignment_id: this.assignment.id,
            };

            if (!this.enabled && !!this.assignment.deadlines.length) {
                this.removeDeadline();
            } else if (this.enabled && this.time && this.date && !!this.assignment.deadlines.length) {
                this.updateDeadline(data);
            } else if (this.enabled && this.time && this.date) {
                this.addDeadline(data);
            }
        },

        addDeadline(data) {
            if (this.groupIn.children.length > 0) {
                this.alert
                    .confirm(
                        this.$t('common.deadline'),
                        this.$t('assignment.add_deadline_confirmation_body'),
                        this.$t('common.save'),
                    )
                    .then((confirm) => {
                        if (confirm) {
                            this.axios.post(this.routes.assignmentDeadline(), data).then(
                                (response) => {
                                    this.$emit('update-deadline', response.data);
                                    this.alert.success();
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                },
                            );
                        }
                    });
            } else {
                this.axios.post(this.routes.assignmentDeadline(), data).then(
                    (response) => {
                        this.$emit('update-deadline', response.data);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },

        updateDeadline(data) {
            if (this.groupIn.children.length > 0) {
                this.alert
                    .confirm(
                        this.$t('portfolio.edit_deadline_confirmation_title'),
                        this.$t('portfolio.edit_deadline_confirmation_body'),
                        this.$t('common.save'),
                    )
                    .then((confirm) => {
                        if (confirm) {
                            this.axios
                                .post(this.routes.assignmentDeadlineUpdate(this.assignment.deadlines[0].id), data)
                                .then(
                                    (response) => {
                                        this.$emit('update-deadline', response.data);
                                        this.alert.success();
                                    },
                                    (error) => {
                                        this.alert.ajaxError(error);
                                    },
                                );
                        }
                    });
            } else {
                this.axios.post(this.routes.assignmentDeadlineUpdate(this.assignment.deadlines[0].id), data).then(
                    (response) => {
                        this.$emit('update-deadline', response.data);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },

        removeDeadline() {
            if (this.groupIn.children.length > 0) {
                this.alert
                    .confirm(
                        this.$t('portfolio.remove_deadline_confirmation_title'),
                        this.$t('portfolio.remove_deadline_confirmation_body'),
                        this.$t('common.save'),
                    )
                    .then((confirm) => {
                        if (confirm) {
                            this.axios
                                .delete(
                                    this.routes.assignmentDeadlineRemove(
                                        this.assignment.deadlines[0].id,
                                        this.groupIn.id,
                                    ),
                                )
                                .then(
                                    (response) => {
                                        this.$emit('update-deadline', { assignment_id: this.assignment.id });
                                        this.alert.success();
                                    },
                                    (error) => {
                                        this.alert.ajaxError(error);
                                    },
                                );
                        }
                    });
            } else {
                this.axios
                    .delete(this.routes.assignmentDeadlineRemove(this.assignment.deadlines[0].id, this.groupIn.id))
                    .then(
                        (response) => {
                            this.$emit('update-deadline', { assignment_id: this.assignment.id });
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
            }
        },
    },
};
</script>

<style scoped lang="scss">
.deadline-toggle {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}
</style>
